import { render, staticRenderFns } from "./PricelistTemplateList.vue?vue&type=template&id=df14b9ba&"
import script from "./PricelistTemplateList.vue?vue&type=script&lang=ts&"
export * from "./PricelistTemplateList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports